export const VALIDATION_SIZE = 'validation.size';
export const VALIDATION_PATTERN = 'validation.pattern';
export const VALIDATION_REQUIRED = 'validation.required';
export const VALIDATION_PAST = 'validation.past';
export const VALIDATION_EMPTY_ASSIGNMENT_BODY = 'validation.empty.assignment.body';
export const VALIDATION_BODY_MALFORMED = 'validation.body.malformed';
export const DUPLICATED_USER = 'duplicated.administrator';
export const DUPLICATED_GROUP = 'duplicated.group';
export const MISSING_USER_ENTITY = 'missing.user.entity';
export const NOT_FOUND_USER_ENTITY = 'notfound.user.entity';
export const MISSING_GROUP_ENTITY = 'missing.group.entity';
export const INTERNAL_SERVER_ERROR = 'internal.server.error';
export const PERMISSION_PARENT_EXISTS = 'permission.parent.exists';
